import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 20H5C4.44772 20 4 19.5523 4 19V11.14C4 10.8807 4.10076 10.6315 4.281 10.445L9.781 4.74502C9.96945 4.54979 10.2292 4.43951 10.5005 4.43951C10.7719 4.43951 11.0315 4.54979 11.22 4.74502L12.871 6.45802L11.438 7.85202L10.5 6.88002L6 11.54V17.995H17V18.995C17.0013 19.2611 16.8966 19.5167 16.7089 19.7054C16.5212 19.894 16.2661 20 16 20ZM17 16H15V13H12V11H15V8.00002H17V11H20V13H17V16Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "HomePlus"
);
